export class AiAssistantConversationMessageDto {
  content: string;
  role: string;
  tokensNumber: number;
}